import script from "./DeviceList.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceList.vue?vue&type=script&setup=true&lang=js"

import "./DeviceList.vue?vue&type=style&index=0&id=783157a9&lang=css"

const __exports__ = script;

export default __exports__